<template >
  <div
    class="modal fade show bg-primary opacity-10"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    style="display: block;"
    aria-modal="true"
    role="dialog"
    v-if="visible === true"
  >
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="avatar-sm" style="margin:15px auto">
            <span
              class="avatar-title rounded-circle"
              v-bind:class="['named-', user.name[0]]"
            >{{ user.name | initials }}</span>
          </div>
          <p class="mb-0">{{user.name | firstAndLast}}, entre com sua senha para desbloquear a tela.</p>
        </div>
        <div class="modal-body">
          <app-form-login destiny="block" :emailDefault="user.email" />
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>
<script>
import AppFormLogin from "@/components/AppFormLogin/AppFormLogin.vue";
import { mapState } from "vuex";
export default {
  components: {
    AppFormLogin
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: ()=>[]
    }
  },
  data() {
    return {};
  },
  computed: mapState(["blockScreen"]),
  created() {
    this.unwatch = this.$store.watch(
      (state, getters) => getters.blockScreenActive,
      (newValue, oldValue) => {
        console.log(`Updating from ${oldValue} to ${newValue}`);
      }
    );
    console.log("app block screen");
  },
  beforeDestroy() {
    this.unwatch();
  }
};
</script>
<style scoped>
.modal-header {
  flex-direction: column;
}
</style>